import React from 'react';

interface IProps {
  color?: string;
  className?: string;
}

const Check = ({ color, className }: IProps) => {
  return (
    <svg className={className} width="12" height="10" viewBox="0 0 12 10" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M3.63769 7.27163C3.7504 7.38561 3.90404 7.44976 4.06434 7.44976C4.22464 7.44976 4.37828 7.38561 4.49099 7.27163L10.2058 1.49203C10.2603 1.43689 10.3277 1.40078 10.4572 1.40078C10.5866 1.40078 10.654 1.43689 10.7085 1.49203C10.7636 1.54768 10.8016 1.61915 10.8016 1.75588C10.8016 1.89262 10.7636 1.96409 10.7085 2.01973L4.31572 8.48504C4.22636 8.57541 4.15085 8.60078 4.06434 8.60078C3.97784 8.60078 3.90232 8.57541 3.81296 8.48504L1.29458 5.9381C1.23956 5.88246 1.20156 5.81099 1.20156 5.67425C1.20156 5.53751 1.23956 5.46604 1.29458 5.4104C1.3491 5.35526 1.41648 5.31915 1.54596 5.31915C1.67543 5.31915 1.74281 5.35526 1.79734 5.4104L3.63769 7.27163Z" stroke={color || "#fff"} strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>

  );
};

export default Check;
